module.exports = __webpack_public_path__ + "static/media/train-card15.32b28b58.jpg";